import React, { useState } from 'react';
import { ConsonantChart } from '../chart/ConsonantChart';
import { speakSegment } from '../speakSegment';
import { getFeaturesForOne, ipaCombiners, IpaType } from '../../phonemes/ipa';
import { ipaToSynthSymbols } from '../../speak/exact';
import { checkExact } from './checkExact';
import { ClickChart } from '../chart/ClickChart';
import { getWithTie } from '../../phonemes/getPossibleCombos';
import { segmentPhonemes } from '../../phonemes/segmentPhonemes';

/** show the IPA consonants supported through eSpeak */
export function SupportedConsonants() {
  const [exactIpa, setExactIpa] = useState('');
  const [approxIpa, setApproxIpa] = useState('');

  function lookup(ipa: IpaType): string {
    const segmented = segmentPhonemes(ipa);
    if (segmented.phonemes.length !== 2) {
      return ipa;
    }
    // add tie-bar between a pair of consonants
    return `${segmented.phonemes[0].phoneme}${ipaCombiners[0]}${segmented.phonemes[1].phoneme}`;
  }
  function canClick(ipa: IpaType): boolean {
    const use = getWithTie(ipa) ?? ipa;
    return ipaToSynthSymbols[use] !== undefined;
  }
  function background(ipa: IpaType): string | undefined {
    const use = getWithTie(ipa) ?? ipa;
    return ipaToSynthSymbols[use] ? 'rgb(200,255,200)' : undefined;
  }

  function ipaClicked(ipa: string) {
    const use = getWithTie(ipa) ?? ipa;
    speakSegment(use);

    const [exact, approx] = checkExact(use);
    setExactIpa(exact);
    setApproxIpa(approx);
  }

  function getSpokenAs() {
    const isSimpleClick = exactIpa.length === 1 && getFeaturesForOne(exactIpa).includes('click');
    return exactIpa === '' ? undefined
      : approxIpa === '' ? `spoken as [${exactIpa}]`
        : isSimpleClick ? `same as [${approxIpa}]`
          : `/${exactIpa}/ approximated as [${approxIpa}]`;
  }

  return (<>
    <ConsonantChart lookup={lookup} canClick={canClick} clicked={ipaClicked}
      includeNonPulmonics={'special'} background={background} />
    <br />
    <ClickChart lookup={lookup} canClick={canClick} clicked={ipaClicked} background={background} />

    <br />{getSpokenAs()}
  </>);
}
